<script>
import ModelCreate from "../models/create";
import FormsModel from "@/components/forms/jala-pond";

export default {
  extends: ModelCreate,
  page: {
    title: "Create JALA Ponds",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('jala_ponds.singular')) }},
    resourceRoute: {default: 'jala_ponds'},
    modelVariable: {default: 'jala_pond'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('jala_ponds.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('jala_ponds.plural')),
          href: "/jala_ponds",
        },
        {
          text: this.$t("Create New"),
          href: "/jala_ponds/create",
          active: true,
        },
      ]
    }
  },
  methods: {
    store(value) {
      return this.$axios.post('/jala/ponds', value);
    }
  }
}
</script>
